// extracted by mini-css-extract-plugin
export default {"message":"LoginByPhoneMessage_message__cydsH"};